import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { AddJobApplication, GetJobApplicationMatch, RequestJobApplicationMatch } from '../models/JobApplications/jobApplication';
import { ApplicationStatusEnum } from '../enums/application-status.enum';

@Injectable({
  providedIn: 'root'
})
export class JobApplicationService {

  constructor(
    private _http: HttpClient
  ) { }

  public addJobApplication(jobApplication: AddJobApplication): Observable<boolean> {
    return this._http.post<any>(`${environment.api.url}/JobApplication`, jobApplication);
  }

  public updateJobApplicationStatus(
    jobApplicationId: number, 
    newStatusId: ApplicationStatusEnum,
    comment?: string
  ): Observable<boolean> {
    return this._http.put<any>(`${environment.api.url}/JobApplication/Status`, {
      jobApplicationId,
      newStatusId,
      comment
    });
  }

  public requestJobApplicationMatch(requestJobApplicationMatch: RequestJobApplicationMatch): Observable<GetJobApplicationMatch[]> {
    return this._http.post<GetJobApplicationMatch[]>(`${environment.api.url}/JobApplication/GetMatch`, requestJobApplicationMatch);
  }

}